// @flow
export default function toUnderscored(s: string) {
  return s.replace(/([A-Z])/g, ($1) => '_' + $1.toLowerCase());
}
